import './EmptyPanel.scss';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface EmptyPanelProps {
  textKey?: string;
  size?: string;
}

const EmptyPanel: React.FC<EmptyPanelProps> = ({ textKey, size = 'xl' }) => {
  const { t } = useTranslation();

  return (
    <div className={`empty-panel empty-panel--${size}`}>
      <div className="empty-panel__icon" />
      <div className="empty-panel__text" dangerouslySetInnerHTML={{ __html: t(textKey || 'noData') }} />
    </div>
  );
};

export default EmptyPanel;
